import React from "react";
import MetricCard from "../MetricCard";

interface CostPerLeadCardProps {
  costPerLead: number;
  timeFrame?: string;
  noData?: boolean;
}

const CostPerLeadCard: React.FC<CostPerLeadCardProps> = ({
  costPerLead,
  timeFrame = "Past 30 days",
  noData = false,
}) => {
  return (
    <MetricCard
      title="Cost Per Lead"
      value={`$${costPerLead.toLocaleString("en-US", {
        maximumFractionDigits: 0,
      })}`}
      min={0}
      max={100}
      current={0}
      // TODO: fix this and fetch data dynamically for industry
      // rightLabel="Industry Avg: $200"
      hideProgress={true}
      hideMinLabel={true}
      preserveHeight={true} // Add this property to maintain consistent height
      className="flex-1"
      tooltip={`Average cost per qualified lead (${timeFrame}). Accounting data since 1st April 2025.`}
      noData={noData}
    />
  );
};

export default CostPerLeadCard;
